import React from "react";

export type i18nType = {
    ChangeLng: () => void,
    setLng: (lng: string) => void,
    lng: string,
}

export const i18nContext = React.createContext<i18nType>({} as i18nType)